class CachedService {
  get( url ) {
    if ( !this.cache ) {
      this.cache = {};
    }
    if ( !this.cache[url] ) {
      // data to keep compatibility with deprecated axios
      this.cache[url] = fetch( url ).then( async resp => ( { data: await resp.text() } ) );
    }
    return this.cache[url];
  }
}
export const cacheService = new CachedService();